import { Permission } from "../types/Permission";

export const formatPermissions = (permissions: string[]): Permission[] => {
    const map = new Map<string, Set<string>>();

    permissions.forEach((permission) => {
        const [resource, actions] = permission.split(":");
        if (!map.has(resource)) {
            map.set(resource, new Set());
        }
        actions.split(",").forEach(action => map.get(resource)!.add(action));
    });

    return Array.from(map.entries()).map(([resource, actionsSet]) => ({
        resource,
        actions: Array.from(actionsSet),
    }));
};
